export default __webpack_public_path__ + "static/media/unspecified.397cc4f0.svg";